<script lang="ts" setup>
import type { NavigationMenuItem } from '#ui/types';

// COMPOSABLE
const accountMenuItems = useAccountMenuItems();
const { logout } = useAuthUtils();
const { tt } = useTypedI18n();
const { trackLogout } = useTracking();

// DATA
const sidenavLink = computed<NavigationMenuItem[][]>(() => [
    ...accountMenuItems.value,
    [
        {
            label: tt('common.logout'),
            icon: 'lucide:log-out',
            onSelect: (): void => {
                trackLogout();
                logout();
            },
        },
    ],
]);
const navigationMenuUi = {
    list: 'space-y-2',
    link: 'gap-3 px-2 py-2',
    linkLeadingIcon: 'size-6',
};
</script>

<template>
    <BasePage class="lg:grid lg:grid-cols-4">
        <div class="mb-9 flex flex-row justify-between lg:col-span-3 lg:col-start-2">
            <BasePageTitle :title="$attrs.title as string" class="mb-0" />
            <slot name="actions" />
        </div>
        <aside class="lg:scrollbar-hide hidden lg:sticky lg:top-[calc(68px+20px)] lg:mr-6 lg:block lg:max-h-[calc(100vh-68px)] lg:overflow-y-auto">
            <UNavigationMenu orientation="vertical" :items="sidenavLink" :ui="navigationMenuUi" color="primary" />
        </aside>
        <div class="flex flex-col gap-6 lg:col-span-3">
            <p v-if="$attrs['sub-title']">{{ $attrs['sub-title'] }}</p>
            <slot />
        </div>
    </BasePage>
</template>
